/**
 * =========================================================================================
 * Cashfree SDK Loader
 * =========================================================================================
 * Dynamic script loader to avoid bundle bloat
 */

let cashfreeSDKPromise = null;
const CASHFREE_SDK_SRC = 'https://sdk.cashfree.com/js/v3/cashfree.js';

export const loadCashfreeSDK = () => {
    if (window.Cashfree) return Promise.resolve(window.Cashfree);
    if (cashfreeSDKPromise) return cashfreeSDKPromise;

    cashfreeSDKPromise = new Promise((resolve, reject) => {
        const handleLoad = () => {
            if (window.Cashfree) {
                resolve(window.Cashfree);
                return;
            }
            reject(new Error('Cashfree SDK loaded but Cashfree is unavailable'));
        };

        const handleError = () => {
            reject(new Error('Failed to load Cashfree SDK'));
        };

        const existingScript = document.querySelector(`script[src="${CASHFREE_SDK_SRC}"]`);
        if (existingScript) {
            existingScript.addEventListener('load', handleLoad, { once: true });
            existingScript.addEventListener('error', handleError, { once: true });
            return;
        }

        const script = document.createElement('script');
        script.src = CASHFREE_SDK_SRC;
        script.async = true;
        script.onload = handleLoad;
        script.onerror = handleError;
        document.head.appendChild(script);
    }).catch((error) => {
        cashfreeSDKPromise = null;
        throw error;
    });

    return cashfreeSDKPromise;
};

// Returns an initialized Cashfree instance with the correct mode.
export const getCashfreeInstance = async () => {
    const Cashfree = await loadCashfreeSDK();
    const mode = window.location.origin?.includes('superworks.com') ? 'production' : 'sandbox';
    return Cashfree({ mode });
};
